<div class="container-fluid product-wrapper" >
    <div class="product-grid">
      <div class="feature-products">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <form>
              <div class="form-group m-0">
                <input class="form-control" type="search" (keydown.enter)="redirectToSearch($event.target)" placeholder="Search.." data-original-title title><i
                  class="fa fa-search"></i>
              </div>
            </form>
          </div>
        </div>
      </div>
      @if(pageNumbers && pageNumbers.length>0){
        <app-rounded-pagination [paginator]="paginator" (paginatorFind)="paginatorFind()"></app-rounded-pagination>
      }
      <div class="product-wrapper-grid" [class.list-view]="listView">
        <app-product-show [productList]="productList"></app-product-show>
      </div>
    </div>
  </div>